export const FEATURES_CONSTANTS = {
  title: "Key benefits of Physical Labs",
  list: [
    {
      label: "Comprehensive Testing Environments",
      text: "Simulate various network configurations and scenarios to assess performance and compatibility.",
    },
    {
      label: "Customizable Infrastructure",
      text: "Adapt hardware and software setups to mirror specific operational environments for accurate testing.",
    },
    {
      label: "Risk Mitigation",
      text: "Identify and address potential issues before they impact live systems, reducing downtime and enhancing reliability.",
    },
    {
      label: "Client Engagement Tools",
      text: "Provide facilities to effectively demonstrate solutions, aiding in sales and customer satisfaction.",
    },
    {
      label: "Educational Resources",
      text: "Access training modules and practical exercises to upskill teams and clients.",
    },
    {
      label: "Collaboration Platforms",
      text: "Create spaces designed to foster teamwork and innovation among different departments and stakeholders.",
    },
  ],
};
